export default "__VITE_ASSET__2b031674__"